import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { AppDispatch, RootState } from 'interfaces';

import Layout from 'components/Layout';
import ToursComponent from 'components/Tours';
import StatisticSideBar from 'components/StatisticSideBar';
import ConcertYearsList from 'components/ConcertYearsList';

import ArrowLink from 'components/ui/ArrowLink';
import Title from 'components/ui/Title';

import {
  getAllShows,
  getMostPlayedSongs,
  getMostPlayedAlbums,
  getYearsOnTour
} from 'features/statistics/statisticsSlice';
import { loadTours } from './toursSlice';

const Tours = () => {
  const intl = useIntl();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(loadTours());
  }, [dispatch]);

  const tours = useSelector((state: RootState) => state.tours.tours);

  useEffect(() => {
    dispatch(getAllShows({ tourId: null }));
    dispatch(getMostPlayedSongs({ tourId: null, albumId: null, limit: 5 }));
    dispatch(getMostPlayedAlbums({ tourId: null, limit: 5 }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getYearsOnTour());
  }, [dispatch]);

  const allShows = useSelector((state: RootState) => state.statistics.allShows);
  const mostPlayedSongs = useSelector((state: RootState) => state.statistics.mostPlayedSongs);
  const mostPlayedAlbums = useSelector((state: RootState) => state.statistics.mostPlayedAlbums);
  const years = useSelector((state: RootState) => state.statistics.years);
  const yearsFes = useSelector((state: RootState) => state.statistics.yearsFes);

  return (
    <Layout sidebar={(
      <StatisticSideBar
        context="tour"
        allShows={allShows}
        mostPlayedSongs={mostPlayedSongs}
        mostPlayedAlbums={mostPlayedAlbums}
        years={years}
      />
    )}>
      <Title size="big" color="secondary">
        {intl.formatMessage({ id: 'tours.title' })}
      </Title>
      <ToursComponent tours={tours} />
      {
        yearsFes ? (
          <React.Fragment>
            <Title size="big" color="secondary">
              {intl.formatMessage({ id: 'concertsAndFestivals.title' })}
            </Title>
            <ConcertYearsList list={yearsFes} isConcertsFestivals />
            <ArrowLink to="/tours-and-shows/shows/festivals-shows-special-events">
              {intl.formatMessage({ id: 'statisticSidebar.onTours.years.linkAll' })}
            </ArrowLink>
          </React.Fragment>
        ) : null
      }
    </Layout>
  );
};

export default Tours;
